import { useId } from 'react';
import { cn } from '@/lib/utils';
import { Switch, SwitchSize } from '@/components/ui/switch.tsx';

export type ToggleSize = SwitchSize;

interface ToggleProps extends React.HTMLAttributes<HTMLSpanElement> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: string;
  /** `md` — 44×26, `sm` — 38×22. */
  size?: ToggleSize;
  disabled?: boolean;
  /** Własny identyfikator; bez niego komponent wygeneruje swój. */
  id?: string;
}

/**
 * Przełącznik z etykietą klikalną razem z nim. Etykieta barwi się stanem, bo
 * przy samym torze trudno na pierwszy rzut oka orzec, czy jest włączony.
 */
const Toggle = ({
  checked,
  onCheckedChange,
  label,
  size = 'md',
  disabled = false,
  id,
  className,
  ...props
}: ToggleProps) => {
  const generatedId = useId();
  const switchId = id ?? generatedId;

  return (
    <span
      className={cn('inline-flex items-center gap-2.5', className)}
      {...props}
    >
      {label && (
        <label
          htmlFor={switchId}
          className={cn(
            'cursor-pointer text-sm font-bold',
            checked ? 'text-accent-900' : 'text-neutral-700',
            disabled && 'cursor-not-allowed opacity-60',
          )}
        >
          {label}
        </label>
      )}
      <Switch
        id={switchId}
        size={size}
        checked={checked}
        disabled={disabled}
        aria-label={label}
        onCheckedChange={onCheckedChange}
      />
    </span>
  );
};

export default Toggle;
